module.exports = __webpack_public_path__ + "static/media/verify.0501e208.png";